import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import { useMapStore } from "../../store/useMapStore";
import L from "leaflet";
import "leaflet.heat";

export const HeatmapLayer: React.FC = () => {
  const map = useMap();
  const { heatmapData } = useMapStore();

  useEffect(() => {
    if (!heatmapData || !heatmapData.points.length) {
      return;
    }

    // Convert heatmap data to leaflet format
    const heatPoints: L.HeatLatLngTuple[] = heatmapData.points.map((point) => [
      point.latitude,
      point.longitude,
      point.intensity / heatmapData.max_intensity, // Normalize intensity
    ]);

    // Create heatmap layer
    const heatLayer = L.heatLayer(heatPoints, {
      radius: 25,
      blur: 15,
      maxZoom: 17,
      max: 1.0,
      gradient: {
        0.0: "blue",
        0.3: "cyan",
        0.5: "lime",
        0.7: "yellow",
        1.0: "red",
      },
    });

    // Add to map
    heatLayer.addTo(map);

    // Cleanup function
    return () => {
      map.removeLayer(heatLayer);
    };
  }, [map, heatmapData]);

  return null;
};
